import { ReadOnlyStepProps } from "../useStepEditor";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { Block } from "../../../../components/atoms";

import { Stack, Title } from "@introist/react-foundation/v2";
import { DataSourceIcon } from "../../../datasources/components/DataSourceIcon";
import { useAutomationStep } from "../../../automations/hooks/useAutomationStep";

export const HarvestDeleteTimeEntryStepViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step) {
    return <div />;
  }

  const { datasourceName, externalReferenceId } = step.resolvedData as any;

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Connection">
          <StepEditorAccordion.Row label="Data source">
            <Stack>
              <DataSourceIcon dataSource="harvest" size="small" />
              <Title variant="bold">{datasourceName}</Title>
            </Stack>
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Time entry details">
          <StepEditorAccordion.Row label="External reference">
            <Title variant="bold">{externalReferenceId}</Title>
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
    </>
  );
};
